import { nodeTitle } from "../../caseFiles/nodeNames";
import type { FsNode } from "../../caseFiles/types";

/** The top-level folder Organize files what it couldn't categorize into. */
export const UNCLASSIFIED_FOLDER = "Unclassified";

export const isUnclassifiedFolder = (node: FsNode): boolean =>
  node.kind === "folder" &&
  node.parent_id === null &&
  nodeTitle(node).trim().toLowerCase() === UNCLASSIFIED_FOLDER.toLowerCase();

/** Files (at any depth) under each top-level Unclassified folder, by folder id. */
export const unclassifiedCounts = (nodes: FsNode[]): Map<string, number> => {
  const live = nodes.filter((n) => !n.is_deleted);
  const byId = new Map(live.map((n) => [n.id, n]));
  const counts = new Map<string, number>();
  live.filter(isUnclassifiedFolder).forEach((f) => counts.set(f.id, 0));
  if (!counts.size) return counts;
  live.forEach((node) => {
    if (node.kind !== "file") return;
    const seen = new Set<string>();
    let parent = node.parent_id;
    while (parent && !seen.has(parent)) {
      if (counts.has(parent)) {
        counts.set(parent, (counts.get(parent) ?? 0) + 1);
        return;
      }
      seen.add(parent);
      parent = byId.get(parent)?.parent_id ?? null;
    }
  });
  return counts;
};

export const needReviewLabel = (count: number): string =>
  `${count} ${count === 1 ? "Needs" : "Need"} Review`;
